import { UserProviderId } from "models/IUser";

const requireEnv = (name: string): string => {
  const value = process.env[name]?.trim();
  if (!value) throw new Error("Missing required env var: " + name);
  return value;
};

export const baseUrl: string = requireEnv("REACT_APP_API_BASE_URL");
export const authHeaderName: string = "Authorization";

export const appsettings: any = {
    clients: {
      "app.excare.io": {
        title: "EXCARE",
        provider: UserProviderId.EXCARE,
        backgroundLoginLeft: "<svg xmlns='http://www.w3.org/2000/svg'  width='20' height='20' viewBox='0 0 100 100'><rect fill='#2ea836' width='100' height='100'/><rect x='0' y='0' width='52' height='52'  fill-opacity='0.8' fill='#FFFFFF'/></svg>",
        logo: "excare_logo.png",
        icon: "excare_icon.png",
        favicon: "excare_favicon.ico",
        description: "",
        features: []
      },
      "champ.excare.io": {
        title: "CHAMP asthma & pollution",
        provider: UserProviderId.CHAMP,
        backgroundLoginLeft: "<svg xmlns='http://www.w3.org/2000/svg'  width='20' height='20' viewBox='0 0 100 100'><rect fill='#0C5B97' width='100' height='100'/><rect x='0' y='0' width='52' height='52'  fill-opacity='0.8' fill='#FFFFFF'/></svg>",
        logo: "champ_logo.png",
        icon: "champ_icon.png",
        favicon: "champ_favicon.ico",
        description: "",
        features: []
      },
      "kore.excare.io": {
        title: "KORE contactless patient monitoring",
        provider: UserProviderId.KORE,
        backgroundLoginLeft: "<svg xmlns='http://www.w3.org/2000/svg'  width='20' height='20' viewBox='0 0 100 100'><rect fill='#0b3d80' width='100' height='100'/><rect x='0' y='0' width='52' height='52'  fill-opacity='0.8' fill='#FFFFFF'/></svg>",
        logo: "kore_logo.png",
        icon: "kore_icon.png",
        favicon: "kore_favicon.ico",
        description: "",
        features: []
      },
      "aiqready.excare.io": {
        title: "Artificial Intelligence for Realtime Distributed Systems at the Edge",
        provider: UserProviderId.AIQReady,
        backgroundLoginLeft: "<svg xmlns='http://www.w3.org/2000/svg'  width='20' height='20' viewBox='0 0 100 100'><rect fill='#152c55' width='100' height='100'/><rect x='0' y='0' width='52' height='52'  fill-opacity='0.8' fill='#FFFFFF'/></svg>",
        logo: "aiqready_logo.png",
        icon: "aiqready_icon.png",
        favicon: "aiqready_favicon.ico",
        description: "",
        features: []
      },
      "smile.excare.io": {
        title: "SMILE – Supporting Mental Health in Young People",
        provider: UserProviderId.SMILE,
        backgroundLoginLeft: "<svg xmlns='http://www.w3.org/2000/svg'  width='20' height='20' viewBox='0 0 100 100'><rect fill='#ff6faa' width='100' height='100'/><rect x='0' y='0' width='52' height='52'  fill-opacity='0.8' fill='#FFFFFF'/></svg>",
        logo: "smile_logo.png",
        icon: "smile_icon.png",
        favicon: "smile_favicon.ico",
        description: "",
        features: []
      },
      "vetllar.encontrol.io": {
        title: "VETLLAR",
        provider: UserProviderId.VETLLAR,
        backgroundLoginLeft: "<svg xmlns='http://www.w3.org/2000/svg'  width='20' height='20' viewBox='0 0 100 100'><rect fill='#8ea0b3' width='100' height='100'/><rect x='0' y='0' width='52' height='52'  fill-opacity='0.8' fill='#FFFFFF'/></svg>",
        logo: "vetllar_logo.png",
        icon: "vetllar_icon.png",
        favicon: "vetllar_favicon.ico",
        description: "",
        features: []
      },
      "aura.excare.io": {
        title: "AURA",
        provider: UserProviderId.AURA,
        backgroundLoginLeft: "<svg xmlns='http://www.w3.org/2000/svg'  width='20' height='20' viewBox='0 0 100 100'><rect fill='#a77cb7' width='100' height='100'/><rect x='0' y='0' width='52' height='52'  fill-opacity='0.8' fill='#FFFFFF'/></svg>",
        logo: "aura_logo.png",
        icon: "aura_icon.png",
        favicon: "aura_favicon.ico",
        description: "",
        features: []
      },
      "icare.excare.io": {
        title: "ICARE",
        provider: UserProviderId.ICARE,
        backgroundLoginLeft: "<svg xmlns='http://www.w3.org/2000/svg'  width='20' height='20' viewBox='0 0 100 100'><rect fill='#ed7d31' width='100' height='100'/><rect x='0' y='0' width='52' height='52'  fill-opacity='0.8' fill='#FFFFFF'/></svg>",
        logo: "icare_logo.png",
        icon: "icare_icon.png",
        favicon: "icare_favicon.ico",
        description: "",
        features: []
      },
      "compass.excare.io": {
        title: "COMPASS",
        provider: UserProviderId.COMPASS,
        backgroundLoginLeft: "<svg xmlns='http://www.w3.org/2000/svg'  width='20' height='20' viewBox='0 0 100 100'><rect fill='#1b98ac' width='100' height='100'/><rect x='0' y='0' width='52' height='52'  fill-opacity='0.8' fill='#FFFFFF'/></svg>",
        logo: "compass_logo.png",
        icon: "compass_icon.png",
        favicon: "compass_favicon.ico",
        description: "",
        features: []
      },
      "certain.excare.io": {
        title: "CERTAIN",
        provider: UserProviderId.CERTAIN,
        backgroundLoginLeft: "<svg xmlns='http://www.w3.org/2000/svg'  width='20' height='20' viewBox='0 0 100 100'><rect fill='#22353c' width='100' height='100'/><rect x='0' y='0' width='52' height='52'  fill-opacity='0.8' fill='#FFFFFF'/></svg>",
        logo: "certain_logo.png",
        icon: "certain_icon.png",
        favicon: "certain_favicon.ico",
        description: "",
        features: []
      },
      default: "app.excare.io",
    }
}